export const MESSAGE_POSITION_PAGE = [
  {id: "b", description: "En bas de chaque page"},
  {id: "d", description: "À la dernière page"},
]

export const MESSAGE_POSITION_NUMERO_PAGE = [
  {id: "a", description: "Aucun"},
  {id: "b", description: "Bas de page"},
  {id: "h", description: "Haut de page"},
]

export const MESSAGE_TYPE = [
  {id: "c", description: "Confirmation"},
  {id: "f", description: "Facture"},
  {id: "e", description: "Courriel"},
  {id: "v", description: "Visiteur"},
  {id: "r", description: "E-Signature"},
  {id: "s", description: "SMS"},
]